<template>
  <div class="jps-mygallery-online">
    <WorkspaceBase :child-component="childComponent" :page="page" :meta="meta" />
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  mygallery: true,
  fixed: true,
  disableFooter: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { page, meta } = await getPageAndCache()
useHead(meta)

const childComponent = defineAsyncComponent(
  () => import('@/components/workspace/WorkspaceList.vue')
)
</script>

<style lang="scss" scoped>
.jps-mygallery-online {
  // スクロールのためのheight調整はWorkspaceBaseで指定
}
</style>
